import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import { prosjektActions, prosjektSelectors } from '../../store/prosjektSlice';
import type { TildelAnsvarligProps } from './TildelAnsvarligProps';
import { useRoleMapping } from '@klp/prosjekt/hooks';
import { ProsjektRoutes } from '@klp/prosjekt/config';
import { KlpModal } from '@klp/design';
import { useTranslation } from 'react-i18next';
import { TildelAnsvarligSelector } from './TildelAnsvarligSelector';

const useStyles = makeStyles(() => ({
    modal: {
        maxWidth: '800px',
    },
}));

export const TildelAnsvarligModal: React.FC<TildelAnsvarligProps> = ({
    prosjektId,
    prosessInstansId,
    kandidatGruppe,
    kandidatGruppeEier,
    currentAnsvarlig,
    activity,
    region,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { activeModalProsessInstansId } = useSelector(prosjektSelectors);
    const { handleMapping: handleRoleMapping } = useRoleMapping();

    const dispatch = useDispatch();
    const { setActiveModalProsessInstansId } = prosjektActions;

    const handleClose = () => {
        dispatch(setActiveModalProsessInstansId(undefined));
    };

    // The modal changes the role on the process (endreProsessAnsvarlig), so it targets
    // the owning role only, not every candidate group that may work on the task.
    const eierRolle = handleRoleMapping(kandidatGruppeEier ?? undefined);
    const modalTitle = eierRolle
        ? t('prosjekt.table.actionMenuItems.tildelRolle', { rolle: eierRolle })
        : `${t('prosjekt.table.tildelAnsvarlig.title')}: ${handleRoleMapping(kandidatGruppe)}`;

    return (
        <KlpModal
            isOpen={!!activeModalProsessInstansId}
            onClose={handleClose}
            titleString={modalTitle}
            className={classes.modal}
        >
            <TildelAnsvarligSelector
                prosjektId={prosjektId}
                prosessInstansId={prosessInstansId!}
                kandidatGruppe={kandidatGruppeEier ?? kandidatGruppe}
                currentAnsvarlig={currentAnsvarlig}
                redirectTo={ProsjektRoutes.projectSchema()}
                activity={activity}
                region={region}
            />
        </KlpModal>
    );
};
